import { defineComponent, ref, toRefs, computed, reactive, watch, nextTick, resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, withCtx, renderSlot, createTextVNode, toDisplayString, createCommentVNode, createVNode, createSlots, createElementVNode, withDirectives, mergeProps, withKeys, vModelDynamic, vShow } from 'vue';
import { s as styleInject } from '../OrInlineInputV3-061441a3.js';
import { onClickOutside } from '@vueuse/core';
import { n as ne, K, _, c as ie, r as re, F as Fs, $ as $s, d as ds } from '../OrAutocompleteV3-8c6de221.js';
import { OrErrorV3 as script$1 } from '../or-error-v3/index.js';
import { OrHintV3 as script$2 } from '../or-hint-v3/index.js';
import { OrIconButtonV3 as script$3 } from '../or-icon-button-v3/index.js';
import { OrInputBoxV3 as script$4, InputBoxVariant } from '../or-input-box-v3/index.js';
import { OrLabelV3 as script$5 } from '../or-label-v3/index.js';
import { OrLoaderV3 as script$6 } from '../or-loader-v3/index.js';
import { OrTagsV3 as script$7, TagsOverflow } from '../or-tags-v3/index.js';
import { TagColor } from '../or-tag-v3/index.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-input-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import './index.js';
import '../or-button-v3/index.js';

const TagInput = [
// Layout
'layout-column',
// Spacing
'gap-xs'];
const TagInputControl = [
// Layout
// 'flex-auto',
// Typography
'typography-inherit',
// Theme (placeholder)
'placeholder:theme-foreground-outline', 'dark:placeholder:theme-foreground-outline-dark'];
const TagInputItem = [
// Box
'!min-h-0'];

var script = defineComponent({
  name: 'OrTagInput',
  components: {
    OrError: script$1,
    OrHint: script$2,
    OrIconButton: script$3,
    OrInputBox: script$4,
    OrLabel: script$5,
    OrLoader: script$6,
    OrTags: script$7
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: () => []
    },
    variant: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    error: {
      type: [String, Boolean],
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    overflow: {
      type: String,
      default: () => TagsOverflow.Hidden
    },
    // todo: review default state, disabling will breaking
    enableClear: {
      type: Boolean,
      default: true
    },
    additionalInputBoxStyles: {
      type: Array,
      default: () => []
    },
    saveOnBlur: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'input', 'keydown', 'keyup', 'focus', 'blur', 'reset'],
  expose: ['root', 'reset', 'clear', 'focus', 'blur', 'activate'],
  setup(props, context) {
    // Refs
    const root = ref();
    const control = ref();
    const inputBox = ref();
    const tags = ref();
    // Props
    const {
      modelValue,
      overflow,
      placeholder,
      disabled,
      readonly,
      saveOnBlur
    } = toRefs(props);
    const {
      isMobile
    } = ne();
    // Styles
    const rootStyles = computed(() => ['or-tag-input-v3', ...TagInput, ...(props.variant === InputBoxVariant.Embedded ? ['grow'] : [])]);
    const controlStyles = computed(() => [...TagInputControl]);
    const itemStyles = computed(() => [...TagInputItem]);
    const inputBoxStyles = computed(() => ['interactivity-select', ...props.additionalInputBoxStyles]);
    // State
    const controlAttributes = reactive({
      id: K(),
      ..._(),
      ...ie()
    });
    const activated = ref(false);
    const proxyModelValue = re(modelValue, context.emit);
    const draftModelValue = ref();
    const tagsItems = computed(() => {
      return Fs(proxyModelValue.value).map(item => ({
        label: item,
        value: item,
        tagProps: {
          color: item === draftModelValue.value ? TagColor.Danger : TagColor.Default
        }
      }));
    });
    const currentLength = computed(() => {
      var _a, _b;
      return (_b = (_a = proxyModelValue.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    });
    const maxLength = computed(() => controlAttributes.maxlength);
    const controlInlineStyles = computed(() => {
      var _a, _b;
      const chars = draftModelValue.value ? draftModelValue.value.length : currentLength.value === 0 ? (_b = (_a = placeholder.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 : 0;
      return {
        width: `${Math.max(chars + 1 || 0, 3)}ch`
      };
    });
    const showControl = computed(() => {
      return draftModelValue.value || currentLength.value === 0 || activated.value;
    });
    const tagsProps = computed(() => ({
      variant: readonly.value || disabled.value || !activated.value ? 'tag' : 'reset',
      disabled: disabled.value
    }));
    // Methods
    function focus() {
      var _a;
      (_a = control.value) === null || _a === void 0 ? void 0 : _a.focus();
    }
    function blur() {
      var _a;
      (_a = control.value) === null || _a === void 0 ? void 0 : _a.blur();
    }
    function deactivate() {
      activated.value = false;
      nextTick(() => blur());
      context.emit('blur');
    }
    function activate() {
      if (disabled.value || readonly.value) return;
      if (!activated.value) {
        activated.value = true;
        context.emit('focus');
      }
      nextTick(() => focus());
    }
    function add() {
      var _a, _b;
      const newItem = draftModelValue.value;
      if (!newItem) return;
      if ((_a = proxyModelValue.value) === null || _a === void 0 ? void 0 : _a.includes(newItem)) return;
      if (maxLength.value && currentLength.value >= maxLength.value) return;
      proxyModelValue.value = $s(newItem, (_b = proxyModelValue.value) !== null && _b !== void 0 ? _b : []);
      draftModelValue.value = '';
    }
    function remove(value) {
      var _a;
      proxyModelValue.value = ds(value, (_a = proxyModelValue.value) !== null && _a !== void 0 ? _a : []);
    }
    function reset() {
      proxyModelValue.value = [];
      draftModelValue.value = '';
      context.emit('reset');
    }
    function clear() {
      draftModelValue.value = '';
    }
    // Effects
    onClickOutside(inputBox, () => {
      var _a, _b;
      if (activated.value === false || ((_b = (_a = tags.value) === null || _a === void 0 ? void 0 : _a.overflowPopover) === null || _b === void 0 ? void 0 : _b.state) === 'open') return;
      if (saveOnBlur.value) add();
      deactivate();
    });
    watch(proxyModelValue, (items, prevItems) => {
      var _a;
      if ((items === null || items === void 0 ? void 0 : items.length) !== (prevItems === null || prevItems === void 0 ? void 0 : prevItems.length) && overflow.value === TagsOverflow.Scroll) {
        ((_a = tags.value) === null || _a === void 0 ? void 0 : _a.scrollToEnd)();
      }
    });
    return {
      root,
      control,
      inputBox,
      tags,
      rootStyles,
      controlStyles,
      itemStyles,
      inputBoxStyles,
      controlInlineStyles,
      controlAttributes,
      proxyModelValue,
      draftModelValue,
      tagsItems,
      tagsProps,
      currentLength,
      maxLength,
      activated,
      showControl,
      isMobile,
      focus,
      blur,
      add,
      activate,
      deactivate,
      remove,
      reset,
      clear
    };
  }
});

const _hoisted_1 = {
  class: "inline-flex w-fit max-w-full"
};
const _hoisted_2 = ["placeholder", "readonly", "disabled"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLabel = resolveComponent("OrLabel");
  const _component_OrTags = resolveComponent("OrTags");
  const _component_OrLoader = resolveComponent("OrLoader");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrInputBox = resolveComponent("OrInputBox");
  const _component_OrHint = resolveComponent("OrHint");
  const _component_OrError = resolveComponent("OrError");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.$slots.label || _ctx.$slots.addon || _ctx.label ? (openBlock(), createBlock(_component_OrLabel, {
    key: 0,
    "control-id": _ctx.controlAttributes.id,
    variant: 'input',
    required: _ctx.required,
    disabled: _ctx.disabled
  }, {
    addon: withCtx(() => [renderSlot(_ctx.$slots, "addon")]),
    default: withCtx(() => [renderSlot(_ctx.$slots, "label", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["control-id", "required", "disabled"])) : createCommentVNode("v-if", true), createVNode(_component_OrInputBox, {
    ref: 'inputBox',
    class: normalizeClass(_ctx.inputBoxStyles),
    variant: _ctx.variant,
    invalid: !!_ctx.error,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    tabindex: 0,
    "force-state": _ctx.activated ? 'focus-within' : undefined,
    onFocus: _ctx.activate
  }, createSlots({
    default: withCtx(() => [createVNode(_component_OrTags, {
      ref: 'tags',
      class: normalizeClass(['grow']),
      items: _ctx.tagsItems,
      disabled: _ctx.disabled,
      "tag-props": _ctx.tagsProps,
      overflow: _ctx.overflow,
      onReset: _cache[6] || (_cache[6] = $event => _ctx.remove($event))
    }, createSlots({
      tag: withCtx(({
        item
      }) => [renderSlot(_ctx.$slots, "tag", {
        item: item
      }, () => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)])]),
      _: 2 /* DYNAMIC */
    }, [_ctx.showControl ? {
      name: "tail",
      fn: withCtx(() => [createElementVNode("div", _hoisted_1, [withDirectives(createElementVNode("input", mergeProps({
        ref: 'control'
      }, _ctx.controlAttributes, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.draftModelValue = $event),
        class: _ctx.controlStyles,
        style: _ctx.controlInlineStyles,
        type: 'text',
        placeholder: !_ctx.proxyModelValue || _ctx.proxyModelValue && _ctx.proxyModelValue.length === 0 ? _ctx.placeholder : undefined,
        readonly: _ctx.readonly,
        disabled: _ctx.disabled,
        autocomplete: 'off',
        minlength: undefined,
        maxlength: undefined,
        onInput: _cache[1] || (_cache[1] = $event => _ctx.$emit('input', $event)),
        onKeydown: [_cache[2] || (_cache[2] = $event => _ctx.$emit('keydown', $event)), _cache[3] || (_cache[3] = withKeys($event => _ctx.add(), ["enter"]))],
        onKeyup: _cache[4] || (_cache[4] = $event => _ctx.$emit('keyup', $event)),
        onFocus: _cache[5] || (_cache[5] = (...args) => _ctx.activate && _ctx.activate(...args))
      }), null, 16 /* FULL_PROPS */, _hoisted_2), [[vModelDynamic, _ctx.draftModelValue, void 0, {
        trim: true
      }]])])]),
      key: "0"
    } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["items", "disabled", "tag-props", "overflow"])]),
    _: 2 /* DYNAMIC */
  }, [_ctx.$slots.prependInner ? {
    name: "prepend",
    fn: withCtx(() => [renderSlot(_ctx.$slots, "prependInner")]),
    key: "0"
  } : undefined, _ctx.$slots.appendInner ? {
    name: "addon",
    fn: withCtx(() => [renderSlot(_ctx.$slots, "appendInner")]),
    key: "1"
  } : _ctx.loading ? {
    name: "addon",
    fn: withCtx(() => [createVNode(_component_OrLoader, {
      variant: 'circular',
      color: _ctx.error ? 'danger' : 'primary',
      size: _ctx.isMobile ? 'm' : 's'
    }, null, 8 /* PROPS */, ["color", "size"])]),
    key: "2"
  } : _ctx.enableClear && !_ctx.readonly && !_ctx.disabled ? {
    name: "addon",
    fn: withCtx(() => [_ctx.proxyModelValue && _ctx.proxyModelValue.length > 0 || _ctx.draftModelValue ? (openBlock(), createBlock(_component_OrIconButton, {
      key: 0,
      icon: 'close',
      color: 'inherit',
      onClick: _cache[7] || (_cache[7] = $event => _ctx.reset())
    })) : createCommentVNode("v-if", true)]),
    key: "3"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "invalid", "readonly", "disabled", "force-state", "onFocus"]), _ctx.$slots.hint || _ctx.hint || _ctx.maxLength ? withDirectives((openBlock(), createBlock(_component_OrHint, {
    key: 1,
    disabled: _ctx.disabled
  }, createSlots({
    default: withCtx(() => [renderSlot(_ctx.$slots, "hint", {}, () => [createTextVNode(toDisplayString(_ctx.hint), 1 /* TEXT */)])]),
    _: 2 /* DYNAMIC */
  }, [_ctx.maxLength ? {
    name: "addon",
    fn: withCtx(() => [createTextVNode(toDisplayString(_ctx.currentLength) + " / " + toDisplayString(_ctx.maxLength), 1 /* TEXT */)]),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"])), [[vShow, !_ctx.error]]) : createCommentVNode("v-if", true), withDirectives(createVNode(_component_OrError, {
    disabled: _ctx.disabled
  }, createSlots({
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.error) + " ", 1 /* TEXT */)]),
    _: 2 /* DYNAMIC */
  }, [_ctx.maxLength ? {
    name: "addon",
    fn: withCtx(() => [createTextVNode(toDisplayString(_ctx.currentLength) + " / " + toDisplayString(_ctx.maxLength), 1 /* TEXT */)]),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"]), [[vShow, typeof _ctx.error === 'string' && _ctx.error.length > 0]])], 2 /* CLASS */);
}

var css_248z = "\ninput[data-v-368ea875] {\n  min-width: 0;\n  background: none;\n  outline: none;\n}\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-368ea875";
script.__file = "src/components/or-tag-input-v3/OrTagInput.vue";

export { script as OrTagInputV3 };
